import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import template from './resetColor.jsx';
import displayNames from '../displayNames';
var ResetColor = /*#__PURE__*/function (_React$Component) {
  function ResetColor(props) {
    var _this;
    _classCallCheck(this, ResetColor);
    _this = _callSuper(this, ResetColor, [props]);
    _this.initialColor = _this.props.value;
    _this.resetColor = function () {
      _this.props.onChange(_this.initialColor);
    };
    return _this;
  }
  _inherits(ResetColor, _React$Component);
  return _createClass(ResetColor, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
ResetColor.displayName = displayNames.RESET_COLOR;
ResetColor.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Current color */
  value: PropTypes.string.isRequired,
  /** Invoked on clicking the reset color element. Parameter: `initialColor` - the color resetting to {string} */
  onChange: PropTypes.func.isRequired
};
ResetColor.defaultProps = {};
export default compose(ResetColor);